export enum CollisionShape {
  Ball = 'ball',
  Cuboid = 'cuboid',
  Capsule = 'capsule',
  Segment = 'segment',
  Polyline = 'polyline',
  Triangle = 'triangle',
  TriMesh = 'trimesh',
  HeightField = 'heightfield',
  Compound = 'compound',
  ConvexPolyhedron = 'convexPolyhedron',
  Cylinder = 'cylinder',
  Cone = 'cone',
  RoundCuboid = 'roundCuboid',
  RoundTriangle = 'roundTriangle',
  RoundCylinder = 'roundCylinder',
  RoundCone = 'roundCone',
  RoundConvexPolyhedron = 'roundConvexPolyhedron',
  HalfSpace = 'halfSpace'
}
